import { EquipmentDragOverride } from 'components/structure-page/3d/equipment-gizmo-3d';
import { ConfigurationType, GridObjectType } from 'data/types';
import { EQUIPMENT_GRID_SQUARES } from 'utils/3d-equipment';

export function applyEquipmentDragOverrideToConfiguration(
  configuration: ConfigurationType | undefined,
  override: EquipmentDragOverride | null,
  objects: GridObjectType[]
): ConfigurationType | undefined {
  if (!configuration || !override) return configuration;

  const object = objects.find((o) => o.id === override.objectId);
  if (!object) return configuration;

  const centerX = Math.round(override.x + EQUIPMENT_GRID_SQUARES / 2);
  const centerY = Math.round(override.y + EQUIPMENT_GRID_SQUARES / 2);

  if (object.type === 'condenser') {
    const condenserUniqueId = object.itemId;
    return {
      ...configuration,
      condensers: configuration.condensers.map((condenser) =>
        condenser.uniqueId === condenserUniqueId
          ? { ...condenser, position: { x: override.x, y: override.y } }
          : condenser
      ),
      lineSets: configuration.lineSets?.map((lineset) => {
        if (
          lineset.condenserUniqueId !== condenserUniqueId ||
          lineset.points.length === 0
        ) {
          return lineset;
        }
        return {
          ...lineset,
          points: lineset.points.map((point, index) =>
            index === 0
              ? { ...point, positionX: centerX, positionY: centerY }
              : point
          )
        };
      })
    };
  }

  if (object.type === 'air-handler') {
    const airHandlerUniqueId = object.itemId;
    return {
      ...configuration,
      condensers: configuration.condensers.map((condenser) => ({
        ...condenser,
        zones: condenser.zones.map((zone) => {
          if (
            !zone.airHandler ||
            zone.airHandler.uniqueId !== airHandlerUniqueId
          ) {
            return zone;
          }
          return {
            ...zone,
            airHandler: {
              ...zone.airHandler,
              positionX: override.x,
              positionY: override.y,
              userPositioned: true
            }
          };
        })
      })),
      lineSets: configuration.lineSets?.map((lineset) => {
        if (
          lineset.airHandlerUniqueId !== airHandlerUniqueId ||
          lineset.points.length === 0
        ) {
          return lineset;
        }
        const lastIndex = lineset.points.length - 1;
        return {
          ...lineset,
          points: lineset.points.map((point, index) =>
            index === lastIndex
              ? { ...point, positionX: centerX, positionY: centerY }
              : point
          )
        };
      })
    };
  }

  return configuration;
}
